export default "__VITE_ASSET__Wut7Eu8Y__"